export default __webpack_public_path__ + "static/19-31a80b745856f481b8795fed2b7b5bde.png";